import React from 'react';
import { Section, SectionHeading } from './Shared';
const points = ['Scegliere gli esercizi all’ultimo momento', 'Accumulare molte idee senza sapere come collegarle', 'Dare indicazioni diverse da una lezione all’altra', 'Perdere tempo nella preparazione', 'Dimenticare osservazioni importanti sugli allievi', 'Proporre sequenze poco adatte al livello del gruppo'];
export const PainPoints = () => <Section className="max-w-4xl" data-id="element-179" data-mp="1xx849v7qhv7c">
    <SectionHeading eyebrow="Il punto di partenza" className="mb-7" data-id="element-180" data-mp="1xw6hithcvk9s">
      Quante lezioni vuoi ancora preparare da zero?
    </SectionHeading>

    <div className="relative max-w-2xl mx-auto mb-9 overflow-hidden rounded-3xl border border-brand-gold/50 bg-brand-greenSage/25 px-6 py-8 sm:px-10 text-center shadow-[0_18px_40px_-28px_rgba(46,40,32,0.6)]" data-id="element-181" data-mp="1nzjzecgez7bg">
      {/* Warm, living decor */}
      <span aria-hidden="true" className="pointer-events-none absolute -top-3 -left-2 text-5xl opacity-40 animate-float-soft select-none" data-id="element-182" data-mp="3iemgpmvb7j3a">
        🪴
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute -bottom-4 -right-1 text-5xl opacity-40 animate-float-soft select-none" style={{
      animationDelay: '1.4s'
    }} data-id="element-183" data-mp="1z0ezwvxo186w">
        🌿
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute top-4 right-6 text-2xl opacity-40 animate-float-soft select-none" style={{
      animationDelay: '2.2s'
    }} data-id="element-184" data-mp="27ti8aptgeuuo">
        🍵
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute bottom-5 left-6 text-2xl opacity-35 animate-float-soft select-none" style={{
      animationDelay: '0.8s'
    }} data-id="element-185" data-mp="1g113868jxjcp">
        🕯️
      </span>

      <div className="relative" data-id="element-186" data-mp="1p3k1ed1e77sm">
        <span aria-hidden="true" className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-brand-paper border border-brand-gold/50 text-xl mb-4" data-id="element-187" data-mp="1p0edh14i2byh">
          🤍
        </span>
        <p className="font-display text-lg sm:text-2xl leading-snug text-brand-purpleDark" data-id="element-188" data-mp="30ftau60mf5u4">
          Conoscere molti esercizi non è lo stesso che avere una{' '}
          <span className="relative inline-block" data-id="element-189" data-mp="1t5ycev8y0x7r">
            <span aria-hidden="true" className="absolute inset-x-[-3px] bottom-[0.08em] h-[0.32em] bg-brand-goldLight/70" data-id="element-190" data-mp="1t7hpye37su5u" />
            <span className="relative font-semibold" data-id="element-191" data-mp="22637c5wya351">struttura chiara</span>
          </span>{' '}
          per trasformarli in una lezione comprensibile.
        </p>
        <p className="mt-3 font-display italic text-base sm:text-lg text-brand-burgundy" data-id="element-192" data-mp="272tvlgiws51j">
          E questa differenza si sente in ogni incontro. 🌱
        </p>
      </div>
    </div>

    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5 max-w-3xl mx-auto mb-8" data-id="element-193" data-mp="1egsa2yet6qvn">
      {points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-194" data-mp="1jd8zdvxqvbab">
          <span aria-hidden="true" className="mt-2 w-1.5 h-1.5 rotate-45 bg-brand-burgundy shrink-0" data-id="element-195" data-mp="1o73q3jbroqiw" />
          <span className="text-brand-text text-sm" data-id="element-196" data-mp="qpwoij0y4rwu">{point}</span>
        </li>)}
    </ul>

    <p className="mx-auto mb-8 max-w-2xl text-center text-sm md:text-base text-brand-text/80 leading-relaxed" data-id="element-197" data-mp="vozmjjiidxvb">
      Con un sistema di riferimento puoi preparare l’incontro con maggiore
      calma, seguire una progressione e lasciare più spazio all’osservazione
      reale delle persone che hai davanti.
    </p>

    <p className="text-center text-xl md:text-2xl font-display font-semibold purple-gradient-text" data-id="element-198" data-mp="e6r96l06mrpl">
      La prossima lezione può essere più semplice da guidare.
    </p>
  </Section>;